import { ILuckyKicksItem } from '@bg-shared/interfaces/ILuckyKicksItem';

// TODO: move to betgames-contract-js

export enum LuckyKicksOptionClasses {
    SCORED_EXACTLY_1_1_1 = 'SCORED_EXACTLY_1_1_1',
    SCORED_EXACTLY_1_1_0 = 'SCORED_EXACTLY_1_1_0',
    SCORED_EXACTLY_1_0_1 = 'SCORED_EXACTLY_1_0_1',
    SCORED_EXACTLY_0_1_1 = 'SCORED_EXACTLY_0_1_1',
    SCORED_EXACTLY_0_0_0 = 'SCORED_EXACTLY_0_0_0',
    SCORED_EXACTLY_1_0_0 = 'SCORED_EXACTLY_1_0_0',
    SCORED_EXACTLY_0_1_0 = 'SCORED_EXACTLY_0_1_0',
    SCORED_EXACTLY_0_0_1 = 'SCORED_EXACTLY_0_0_1',
    SCORED_3 = 'SCORED_3',
    SCORED_2 = 'SCORED_2',
    SCORED_1 = 'SCORED_1',
    SCORED_0 = 'SCORED_0',
}

export const LuckyKicksOptions: Record<LuckyKicksOptionClasses, ILuckyKicksItem> = {
    [LuckyKicksOptionClasses.SCORED_EXACTLY_1_1_1]: {
        items: [{ number: 1 }, { number: 1 }, { number: 1 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_0_0_0]: {
        items: [{ number: 0 }, { number: 0 }, { number: 0 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_1_1_0]: {
        items: [{ number: 1 }, { number: 1 }, { number: 0 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_1_0_0]: {
        items: [{ number: 1 }, { number: 0 }, { number: 0 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_1_0_1]: {
        items: [{ number: 1 }, { number: 0 }, { number: 1 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_0_1_0]: {
        items: [{ number: 0 }, { number: 1 }, { number: 0 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_0_1_1]: {
        items: [{ number: 0 }, { number: 1 }, { number: 1 }],
    },
    [LuckyKicksOptionClasses.SCORED_EXACTLY_0_0_1]: {
        items: [{ number: 0 }, { number: 0 }, { number: 1 }],
    },
    [LuckyKicksOptionClasses.SCORED_3]: { items: [{ number: 1 }], number: 3 },
    [LuckyKicksOptionClasses.SCORED_2]: { items: [{ number: 1 }], number: 2 },
    [LuckyKicksOptionClasses.SCORED_1]: { items: [{ number: 1 }], number: 1 },
    [LuckyKicksOptionClasses.SCORED_0]: { items: [{ number: 1 }], number: 0 },
};
